export default __webpack_public_path__ + "static/media/shop.15796672.jpg";